import { OfferPageActions, takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import type { MouseEvent } from 'react'
import { useCallback, useContext, useRef } from 'react'
import { useIntl } from 'react-intl'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import AssistChip from 'LuxKit/Chips/AssistChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import OfferCalendarBundlePackageDropdown from './OfferCalendarBundlePackageDropdown'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  open: boolean
}

function OfferCalendarBundlePackageSelect(props: Props) {
  const { open } = props
  const intl = useIntl()
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)
  const dispatch = useOfferPageDispatch()

  const onClose = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()

    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
    onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenPackage)
  }, [onUserAnalyticsAction, dispatch])

  const onOpen = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()

    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
    onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.OpenSubFilter, CALENDAR_GA_EVENT_LABEL.OpenPackage)
  }, [onUserAnalyticsAction, dispatch])

  const onAssistToggle = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    if (open) {
      onClose(e)
    } else {
      onOpen(e)
    }
  }, [open, onClose, onOpen])

  return (
    <>
      <AssistChip variant="outline" size="medium" ref={triggerRef} onClick={onAssistToggle} endIcon={<DropdownChevron open={open} />}>
        {intl.formatMessage({
          id: '3xdRtrBB41LJngZE4Khx',
          defaultMessage: 'Filter by bundle',
        })}
      </AssistChip>
      <DropdownList
        size="S"
        open={open}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        onClose={onClose}
      >
        <OfferCalendarBundlePackageDropdown onClose={onClose} />
      </DropdownList>
    </>
  )
}

export default withOfferPageState((currentState) => {
  const state = takeCurrentOfferState(currentState)

  return {
    open: state.activeSubFilter === 'room',
  }
}, OfferCalendarBundlePackageSelect)
